module.exports = __webpack_public_path__ + "img/暂无数据.65b38c35.png";